module.exports = __webpack_public_path__ + "static/img/netPolice.58f55c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/netPolice.png
// module id = 2Kv7
// module chunks = 0